import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/leave-applications`;

const LeaveApplication = () => {
    const [leaveApplication, setleaveApplication] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [selectedleaveApplication, setSelectedleaveApplication] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const WithListPermission = withPermission(({ children }) => children, ['leaveapply-list']);
    const WithCreatePermission = withPermission(({ children }) => children, ['leaveapply-create']);
    const WithDeletePermission = withPermission(({ children }) => children, ['leaveapply-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['leaveapply-edit']);
    const [searchQuery, setSearchQuery] = useState('');
    const [errors, setErrors] = useState({});
    const [employees, setEmployees] = useState([]);
    const [leaveApplicationTypes, setleaveApplicationTypes] = useState([]);
    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchleaveApplication(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchleaveApplication = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setleaveApplication(response.data?.data || []);
            setPageCount(response.data.last_page);
            setCurrentPage(response.data.current_page);


        } catch (error) {
            console.error('Error fetching leaveApplication:', error);
        }
    };

    const fetchEmployees = async () => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;

        const res = await axios.get(`${backendUrl}/api/employee`, {
            headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
            skipLoader: true,
        });
        setEmployees(res.data?.data || []);
    };

    const fetchleaveApplicationTypes = async () => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;

        const res = await axios.get(`${backendUrl}/api/leave-types`, {
            headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
            skipLoader: true,
        });
        setleaveApplicationTypes(res.data?.data || []);
    };
    useEffect(() => {
        if (showModal) {
            fetchEmployees();
            fetchleaveApplicationTypes();
        }
    }, [showModal]);


    const handleAddleaveApplication = () => {
        const today = new Date().toISOString().split("T")[0];

        setFormData({
            apply_date: today,
            employee_id: '',
            leave_type_id: '',
            leave_mode: '',   // halfday | singleday | multipleday
            first_half: false,     // Initialize as false (boolean)
            second_half: false,    // Initialize as false (boolean)
            start_date: '',
            end_date: '',
            reason: '',
            attatchment: null,
            status: 'pending',
        });

        setIsEdit(false);
        setIsView(false);
        setSelectedleaveApplication(null);
        setShowModal(true);
    };


const handleEditleaveApplication = (leaveApplication) => {
    // Keep the existing attachment path (it might be a string)
    const formDataForEdit = {
        ...leaveApplication,
        first_half: leaveApplication.first_half === true || leaveApplication.first_half === 'true' || leaveApplication.first_half === 1,
        second_half: leaveApplication.second_half === true || leaveApplication.second_half === 'true' || leaveApplication.second_half === 1,
        attatchment: leaveApplication.attatchment, // Keep the existing file path
    };
    
    setFormData(formDataForEdit);
    setIsEdit(true);
    setIsView(false);
    setSelectedleaveApplication(leaveApplication);
    setShowModal(true);
};

const handleViewleaveApplication = (leaveApplication) => {
    const formDataForView = {
        ...leaveApplication,
        first_half: leaveApplication.first_half === true || leaveApplication.first_half === 'true' || leaveApplication.first_half === 1,
        second_half: leaveApplication.second_half === true || leaveApplication.second_half === 'true' || leaveApplication.second_half === 1,
        attatchment: leaveApplication.attatchment,
    };

    setFormData(formDataForView);
    setIsEdit(false);
    setIsView(true);
    setSelectedleaveApplication(leaveApplication);
    setShowModal(true);
};

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setleaveApplication(leaveApplication.filter(leaveApplication => leaveApplication.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The leaveApplication has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting leaveApplication:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete leaveApplication. Please try again.",
                        "error"
                    );
                }
            }
        });

    };
    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;

        // For checkboxes, convert to boolean
        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked, // This will be true/false (boolean)
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };


    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchleaveApplication(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.employee_id) {
            newErrors.employee_id = "Employee is required";
        }

        if (!formData.leave_type_id) {
            newErrors.leave_type_id = "leave type is required";
        }



        return newErrors;
    };


    const [loading, setLoading] = useState(false);

    // const handleSubmit = async () => {
    //     const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //     const origin = localStorage.getItem('user-origin');
    //     const token = userInfo?.token;
    //     const validationErrors = validateForm();
    //     if (Object.keys(validationErrors).length > 0) {
    //         setErrors(validationErrors);
    //         setLoading(false);
    //         return; // Stop here if validation fails
    //     }
    //     try {
    //         if (isEdit) {
    //             const response = await axios.put(`${API_URL}/${selectedleaveApplication.id}`, formData, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 },
    //             });
    //             setleaveApplication(leaveApplication.map(ind => (ind.id === selectedleaveApplication.id ? response.data.data : ind)));
    //         } else {
    //             const response = await axios.post(API_URL, formData, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 },
    //             });
    //             setleaveApplication([...leaveApplication, response.data.data]);
    //         }
    //         setShowModal(false);
    //     } catch (error) {
    //         console.error('Error saving leaveApplication:', error);
    //     }
    // };
const handleSubmit = async () => {
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    const origin = localStorage.getItem('user-origin');
    const token = userInfo?.token;
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
    }

    try {
        // Create FormData object
        const formDataToSend = new FormData();

        // Append all form fields
        formDataToSend.append('employee_id', formData.employee_id || '');
        formDataToSend.append('leave_type_id', formData.leave_type_id || '');
        formDataToSend.append('apply_date', formData.apply_date || '');
        formDataToSend.append('leave_mode', formData.leave_mode || '');
        formDataToSend.append('reason', formData.reason || '');
        formDataToSend.append('status', formData.status || 'pending');

        // Conditional fields - convert boolean to string/integer for Laravel
        if (formData.first_half !== undefined) {
            formDataToSend.append('first_half', formData.first_half ? 'true' : 'false');
        }
        if (formData.second_half !== undefined) {
            formDataToSend.append('second_half', formData.second_half ? 'true' : 'false');
        }
        if (formData.start_date) {
            formDataToSend.append('start_date', formData.start_date);
        }
        if (formData.end_date) {
            formDataToSend.append('end_date', formData.end_date);
        }

        // Attachment: only send when a new file is selected
        if (formData.attatchment instanceof File) {
            formDataToSend.append('attatchment', formData.attatchment);
        }

        console.log('FormData being sent:');
        for (let [key, value] of formDataToSend.entries()) {
            console.log(key, value);
        }

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
                'Content-Type': 'multipart/form-data',
            },
        };

        if (isEdit) {
            formDataToSend.append('_method', 'PUT');
            const response = await axios.post(
                `${API_URL}/${selectedleaveApplication.id}`,
                formDataToSend,
                config
            );
            setleaveApplication(leaveApplication.map(ind =>
                (ind.id === selectedleaveApplication.id ? response.data.data : ind)
            ));
        } else {
            const response = await axios.post(API_URL, formDataToSend, config);
            setleaveApplication([...leaveApplication, response.data.data]);
        }

        setShowModal(false);
        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Leave application ${isEdit ? 'updated' : 'created'} successfully!`,
        });
    } catch (error) {
        console.error('Error saving leaveApplication:', error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Failed to save leave application',
        });
    }
};


    const today = new Date().toISOString().split("T")[0];
    const isReadOnly = isView;
    const attachmentUrl = typeof formData.attatchment === 'string' && formData.attatchment
        ? (formData.attatchment.startsWith('http')
            ? formData.attatchment
            : `${backendUrl}/storage/${formData.attatchment.replace(/^storage\//, '')}`)
        : '';
    const getStatusBadge = (status) => {
        switch (status) {
            case 'approved':
                return <span className="badge bg-success">Approved</span>;
            case 'rejected':
                return <span className="badge bg-danger">Rejected</span>;
            default:
                return <span className="badge bg-warning">Pending</span>;
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Leave Application</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddleaveApplication}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title='Add leaveApplication'
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Apply Date</th>
                                                <th className="align-middle"> leave Type</th>
                                                <th className="align-middle"> Employee</th>
                                                <th className="align-middle"> Leave Date</th>
                                                <th className="align-middle"> Status</th>
                                                <th className="align-middle">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leaveApplication.map((leaveApplication, index) => (
                                                <tr key={leaveApplication.id}>
                                                    <td>
                                                        <div className="form-check font-size-16">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`instanceCheck${index}`}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`instanceCheck${index}`}
                                                            ></label>
                                                        </div>
                                                    </td>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn dropdown-link p-0"
                                                            onClick={() => handleViewleaveApplication(leaveApplication)}
                                                        >
                                                            {leaveApplication.apply_date}
                                                        </button>
                                                    </td>
                                                    <td>{leaveApplication.leave_type?.name}</td>
                                                    <td>{leaveApplication.employee?.first_name}</td>

                                                    <td>{leaveApplication.start_date}</td>
                                                    <td>{getStatusBadge(leaveApplication.status)}</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditleaveApplication(leaveApplication)}>
                                                                            Edit
                                                                        </button>
                                                                    </WithEditPermission>
                                                                </li>
                                                                <li>
                                                                    <WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(leaveApplication.id)}>
                                                                            Delete
                                                                        </button>
                                                                    </WithDeletePermission>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit leaveApplication */}

                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '500px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>
                                                {isView ? 'View Leave Application' : isEdit ? 'Edit leaveApplication Type' : 'Add leaveApplication Type'}
                                            </Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Apply Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="apply_date"
                                                        value={formData.apply_date || today}
                                                        onChange={handleInputChange}
                                                        disabled={isReadOnly}
                                                        className='form-feild'

                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Employee</Form.Label>
                                                <Form.Select name="employee_id" className='form-feild' value={formData.employee_id} onChange={handleInputChange} disabled={isReadOnly}>
                                                    <option value="">Select Employee</option>
                                                    {employees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.first_name} {emp.last_name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                    {errors.employee_id && <div className="text-danger">{errors.employee_id}</div>}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>leave Type</Form.Label>
                                                <Form.Select name="leave_type_id" className='form-feild' value={formData.leave_type_id} onChange={handleInputChange} disabled={isReadOnly}>
                                                    <option value="">Select leave Type</option>
                                                    {leaveApplicationTypes.map(lt => (
                                                        <option key={lt.id} value={lt.id}>{lt.name}</option>
                                                    ))}
                                                </Form.Select>
                                                    {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Leave</Form.Label>
                                                    <Form.Select
                                                        style={{ fontSize: "13px" }}
                                                        name="leave_mode"
                                                        value={formData.leave_mode}
                                                        onChange={handleInputChange}
                                                        disabled={isReadOnly}
                                                        className='form-feild'
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="halfday">Half Day</option>
                                                        <option value="singleday">Single Day</option>
                                                        <option value="multipleday">Multiple Day</option>

                                                    </Form.Select>
                                                </Form.Group>
                                                {formData.leave_mode === "halfday" && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="First Half"
                                                            name="first_half"
                                                            checked={!!formData.first_half} // Ensure boolean for checked prop
                                                            onChange={handleInputChange}
                                                            disabled={isReadOnly}
                                                        />
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Second Half"
                                                            name="second_half"
                                                            checked={!!formData.second_half} // Ensure boolean for checked prop
                                                            onChange={handleInputChange}
                                                            disabled={isReadOnly}
                                                        />
                                                    </Form.Group>
                                                )}

                                                {formData.leave_mode === "singleday" && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='form-font'>Leave Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="start_date"
                                                            value={formData.start_date || ""}
                                                            onChange={handleInputChange}
                                                            disabled={isReadOnly}
                                                            className='form-feild'
                                                        />
                                                    </Form.Group>
                                                )}
                                                {formData.leave_mode === "multipleday" && (
                                                    <>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className='form-font'>From</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="start_date"
                                                                value={formData.start_date || ""}
                                                                onChange={handleInputChange}
                                                                disabled={isReadOnly}
                                                                className='form-feild'
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className='form-font'>To</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="end_date"
                                                                value={formData.end_date || ""}
                                                                onChange={handleInputChange}
                                                                disabled={isReadOnly}
                                                                className='form-feild'
                                                            />
                                                        </Form.Group>
                                                    </>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Reason</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="reason"
                                                        value={formData.reason || ""}
                                                        onChange={handleInputChange}
                                                        disabled={isReadOnly}
                                                        className='form-feild'
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Attachment</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        name="attatchment"  // Already correct with double 't'
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({ ...prev, attatchment: e.target.files[0] }))
                                                        }
                                                        disabled={isReadOnly}
                                                        className='form-feild'
                                                    />
                                                </Form.Group>
                                                {isView && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='form-font'>Attachment Preview</Form.Label>
                                                        {attachmentUrl ? (
                                                            <iframe
                                                                title="Attachment Preview"
                                                                src={attachmentUrl}
                                                                style={{ width: '100%', height: '240px', border: '1px solid #e5e5e5' }}
                                                            />
                                                        ) : (
                                                            <div className="text-muted">No attachment available.</div>
                                                        )}
                                                    </Form.Group>
                                                )}




                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            {!isView && (
                                                <Button variant="primary" onClick={handleSubmit}>
                                                    {isEdit ? 'Update' : 'Save'}
                                                </Button>
                                            )}
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaveApplication;
